const modelViewers = {
  generationModeSiloRender: 'silo render',
  studioRender: 'Studio Render',
  renderingImage: 'Рендеринг изображения',
  renderingImageDescription1:
    'Ваша модель отправлена на сервер рендеринга под тем же углом обзора, который вы задали, и кадрирована по соотношению сторон, выбранному в разделе <accent>Display settings</accent>.',
  renderingImageDescription2:
    'Сейчас она рендерится с высококачественными материалами и студийным освещением — в среднем это занимает около 1 минуты.',
  renderingImageDescription3:
    'Пожалуйста, не закрывайте это окно до завершения рендеринга.',
  lifestyleSceneDescription: 'Сгенерировать lifestyle-сцену с помощью ИИ',
  siloSceneDescription: 'Улучшить материалы модели на белом фоне',
  closeUpSceneDescription: 'Сгенерировать крупный план модели',
  createProductLifestyle: 'Создать lifestyle из 3D-студийного рендера',
  createProductLifestyleShort: 'Создать студийный lifestyle'
};

export default modelViewers;
